import axios from 'axios'

import store from '@/store'

export default {
  getItemDetail (payload) {
    let params = `${payload.path}/?id=${payload.id}`
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      }
    })
      .then(response => response.data)
  },
  getItems (payload) {
    let params = `${payload.path}?offset=${payload.offset}&limit=${payload.limit}`
    if (payload.term) {
      params += `&term=${payload.term}`
    }
    if (payload.order) {
      params += `&order=${payload.order}`
    }
    if (payload.orderBy) {
      params += `&order_by=${payload.orderBy}`
    }
    if (payload.dateFrom) {
      params += `&date_from=${payload.dateFrom}`
    }
    if (payload.dateUpTo) {
      params += `&date_up_to=${payload.dateUpTo}`
    }
    return axios.get(params, {
      headers: {
        Authorization: `Bearer ${store.state.session.accessToken}`
      }
    })
      .then(response => response.data)
  }
}
